export default [
  '/SignIn',
  '/LenovoModuleSelect',
  '/Intelligence/installer',
  // 第三方相关
  '/CloudDisk/SignIn',
  '/CloudDisk/Market'
]